import Constant from "../constant/config"

class Table {

    serviceTable        = {}
    characteristicTable = {}

    constructor() {
        Constant.DEFAULT_SERVICE.forEach((item, key, index) => {
            this.serviceTable[Table.canonicalUUID(item.uuid)] = item.serviceName
        })

        for (let item in Constant.DEFAULT_CHARACTERISTIC) {
            const value = Constant.DEFAULT_CHARACTERISTIC[item]
            const uuid  = Table.canonicalUUID(value)
            let newItem = []
            item.split(/[_\.]+/g).forEach(item => {
                newItem.push(item.replace(/\b(\w)(\w*)/g, function ($0, $1, $2) {
                    return $1.toUpperCase() + $2.toLowerCase();
                }))
            })
            newItem                        = newItem.join(' ')
            this.characteristicTable[uuid] = newItem
        }
        console.log(this.characteristicTable)
    }

    findServiceName(uuid) {
        let serviceName = this.serviceTable[uuid]
        if (serviceName) {
            return serviceName
        }

        return "Custom Service"
    }


    findCharacteristicName(uuid) {
        let characteristicName = this.characteristicTable[uuid]
        if (characteristicName) {
            return characteristicName
        }

        return `Unknow Characteristic: ${uuid}`
    }


    static canonicalUUID(uuidAlias) {
        // https://www.bluetooth.com/specifications/assigned-numbers/service-discovery
        uuidAlias >>>= 0;  // Make sure the number is positive and 32 bits.
        let strAlias = `0000000${uuidAlias.toString(16)}`;
        strAlias     = strAlias.substr(-8);
        return strAlias + '-0000-1000-8000-00805f9b34fb';
    }

}

let table = new Table()
export default table


//
// DEFAULT_NAME_TABLE = {
//     "alert_notification"           : canonicalUUID(0x1811),
//     "automation_io"                : canonicalUUID(0x1815),
//     "battery_service"              : canonicalUUID(0x180F),
//     "blood_pressure"               : canonicalUUID(0x1810),
//     "body_composition"             : canonicalUUID(0x181B),
//     "bond_management"              : canonicalUUID(0x181E),
//     "continuous_glucose_monitoring": canonicalUUID(0x181F),
//     "current_time"                 : canonicalUUID(0x1805),
//     "cycling_power"                : canonicalUUID(0x1818),
//     "cycling_speed_and_cadence"    : canonicalUUID(0x1816),
//     "device_information"           : canonicalUUID(0x180A),
//     "environmental_sensing"        : canonicalUUID(0x181A),
//     "generic_access"               : canonicalUUID(0x1800),
//     "generic_attribute"            : canonicalUUID(0x1801),
//     "glucose"                      : canonicalUUID(0x1808),
//     "health_thermometer"           : canonicalUUID(0x1809),
//     "heart_rate"                   : canonicalUUID(0x180D),
//     "human_interface_device"       : canonicalUUID(0x1812),
//     "immediate_alert"              : canonicalUUID(0x1802),
//     "indoor_positioning"           : canonicalUUID(0x1821),
//     "internet_protocol_support"    : canonicalUUID(0x1820),
//     "link_loss"                    : canonicalUUID(0x1803),
//     "location_and_navigation"      : canonicalUUID(0x1819),
//     "next_dst_change"              : canonicalUUID(0x1807),
//     "phone_alert_status"           : canonicalUUID(0x180E),
//     "pulse_oximeter"               : canonicalUUID(0x1822),
//     "reference_time_update"        : canonicalUUID(0x1806),
//     "running_speed_and_cadence"    : canonicalUUID(0x1814),
//     "scan_parameters"              : canonicalUUID(0x1813),
//     "tx_power"                     : canonicalUUID(0x1804),
//     "user_data"                    : canonicalUUID(0x181C),
//     "weight_scale"                 : canonicalUUID(0x181D)
// };